import React, { Component } from 'react';
import { EditPriorityProps, EditPriorityState } from '../../interfaces/priority'
import { connect } from 'react-redux'
import jwt from 'jsonwebtoken'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import { Link, Redirect } from 'react-router-dom';
import config from '../config/setting'
import CheckChanges from '../confirmOnLeave';
import { editPriority, getPriority } from '../../redux/actions/priority';
import { logoutUser } from './../../redux/actions/user';

class EditPriority extends Component<EditPriorityProps, EditPriorityState> {
    constructor(props: any) {
        super(props);
        this.state = {
            name: "",
            response_time: "",
            resolution_time: "",
            status: "1",
            isActive: "1"
        }
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let id = this.props.match.params.id;
        this.props.getPriority(id);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        console.log("nextProps", nextProps.priority);
        this.setState({
            name: nextProps.priority.ticket_priority_description,
            response_time: nextProps.priority.response_time,
            resolution_time: nextProps.priority.resolution_time,
            status: nextProps.priority.status,
        });
    }
    handleInputChange(event: { target: { name: any; value: any; }; }) {
        if(event.target.value[0]==" "){
        }else{
          this.setState({
              [event.target.name]: event.target.value,
          });
        }
    }

    isCatReady = () => {
        const { name, response_time, resolution_time } = this.state
        return (name !== "" && response_time !== "" && resolution_time);
    }

    handleSaveBtnClick = (event: any) => {
        let { name, response_time, resolution_time, status } = this.state;
        let id = this.props.match.params.id;
        let data = {
            ticket_priority_description: name,
            resolution_time: resolution_time,
            response_time: response_time,
            status: status,
            isActive: config.ACTIVE
        }

        console.log("dataa", data);
        this.props.editPriority(id, data);
    }
    render() {
        if (sessionStorage.token) {
            jwt.verify(sessionStorage.token, config.secretKey, (err: any, decoded: any) => {
                if (err) {
                    this.props.logoutUser();
                }
            });
        } else {
            return <Redirect to="/" />
        }
        let msg;
        let messcolor;
        // const { isInserted, message, brands, channels, types } = this.props;
        // if (isInserted) {
        //     msg = message;
        //     messcolor = 'green'
        // } else {
        //     msg = message;
        //     messcolor = 'red'
        // }
        const { priority } = this.props;
        console.log("this.props", priority);

        return (
            <div className="page">
                <CheckChanges path="/edit-priority" />
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        {/* <!-- Page Header--> */}
                        <header className="page-header pb-1">
                            <div className="container-fluid">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h4>Priority Management</h4>
                                </div>
                            </div>
                        </header>
                        {/*  Breadcrumb */}
                        <div className="breadcrumb-holder container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/priorities" className="text-primary">Priority</Link></li>
                                <li className="breadcrumb-item active">Edit Priority</li>
                            </ul>
                        </div>
                        <section className="forms">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body pt-xl-0">
                                                <strong><p className="text-center font-weight-light mb-4" style={{ color: messcolor }}>
                                                    {msg}
                                                </p></strong>

                                                <div className="form-horizontal p-xl-4">

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Name<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="name" type="text" name="name" defaultValue={priority.ticket_priority_description} required data-msg="Please enter Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Response Time <span className="text-danger"><small>(minutes)</small>*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="response_time" type="number" min="0" defaultValue={priority.response_time} name="response_time" required data-msg="Please enter Response Time" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Resolution Time <span className="text-danger"><small>(minutes)</small>*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="resolution_time" type="number" min="0" defaultValue={priority.resolution_time} name="resolution_time" required data-msg="Please enter Resolution Time" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Status<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="status" value={this.state.status} className="form-control text-capitalize mt-2" required data-msg="Please select status" onChange={this.handleInputChange}>
                                                                <option {...priority.status === config.ACTIVE && { selected: true }} value={config.ACTIVE}>Active</option>
                                                                <option {...priority.status === config.INACTIVE && { selected: true }} value={config.INACTIVE}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="form-group float-right mt-3">
                                                    <button className='btn btn-primary' disabled={!this.isCatReady()} onClick={this.handleSaveBtnClick}>Update Priority</button>
                                                </div>
                                            </div>
                                        </div >
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    console.log("state", state);
    return {
        priority: state.priority.priority
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        editPriority: function (id: any, data: any) {
            dispatch(editPriority(id, data))
        },
        getPriority: function (id: any) {
            dispatch(getPriority(id))
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditPriority);